import script from "./TitlePage.vue?vue&type=script&setup=true&lang=js"
export * from "./TitlePage.vue?vue&type=script&setup=true&lang=js"

import "./TitlePage.vue?vue&type=style&index=0&id=90d33d14&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90d33d14"]])

export default __exports__